import { openModal } from '@core/components/ModalStack';
import { SelectDateModalProps } from './SelectDateModal';

export async function openSelectDateModal(props: SelectDateModalProps) {
  const { SelectDateModal } = await import('./SelectDateModal');

  openModal(SelectDateModal, props);
}
